
import { computed, defineComponent, Ref, ref, PropType, ComputedRef } from 'vue';

export default defineComponent({
    name: 'ExpandHeightToggle',
    props: {
        textList: {
            type: Array as PropType<string[]>,
            required: true,
        },
    },
    setup(props) {
        const textWrapperElement: Ref<HTMLElement | null> = ref(null);
        const showReadMoreSection: Ref<boolean> = ref(false);
        const expandedHeight: Ref<number> = ref(0);

        const firstParagraph: ComputedRef<string> = computed(() => {
            return props.textList.slice(0, 1)[0];
        });

        const allExceptFirstParagraph: ComputedRef<string[]> = computed(() => {
            return props.textList.slice(1);
        });

        const toggleShowReadMoreSection = () => {
            showReadMoreSection.value = !showReadMoreSection.value;
            expandedHeight.value = showReadMoreSection.value ? textWrapperElement.value?.offsetHeight ?? 0 : 0;
        };

        return {
            allExceptFirstParagraph,
            expandedHeight,
            firstParagraph,
            showReadMoreSection,
            textWrapperElement,
            toggleShowReadMoreSection,
        };
    },
});
